import { API_URL } from "../config/connect";

/**
 * Trade the fresh Google JWT for a 24h Agroland admin-session token.
 * Backend accepts both, so replacing localStorage["google_id_token"] with
 * the returned session token is transparent to every existing API module.
 */
export async function exchangeAdminSession(googleIdToken) {
  const res = await fetch(`${API_URL}/api/v1/admin/session/exchange`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${googleIdToken}`,
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    let detail = "session exchange failed";
    try {
      const d = await res.json();
      if (typeof d?.detail === "string") detail = d.detail;
    } catch {}
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  return res.json();
}
